export default __webpack_public_path__ + "static/media/logo.05cc0f9e.png";